<!-- <mat-toolbar>
    <mat-toolbar-row>
        <span>
            <a href="/inicio">
                <img src="../../../assets/images/logolascondes.png" alt="Inicio icono" width="190px" height="90px">
            </a>
        </span>
        <span class="example-spacer"></span>
        <div *ngIf="!identity || !token">
            <button mat-button (click)="sign(true, 'expedientes')">
                <mat-icon mat-button>touch_app</mat-icon>
                Iniciar sesión
            </button>
        </div>
        <div *ngIf="identity || token">
            <button mat-button style="color: white !important" (click)="openPerfil()">
                {{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}
            </button>
            <button mat-button [matMenuTriggerFor]="menu">
                <mat-icon mat-button [matMenuTriggerFor]="menu">settings
                </mat-icon> Opciones
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item href="">
                    <mat-icon>build
                    </mat-icon>Ajustes
                </button>
                <button mat-menu-item href="" (click)="logout()">
                    <mat-icon>exit_to_app
                    </mat-icon>Cerrar Sesi&oacute;n
                </button>
            </mat-menu>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
<div class="linea"></div>

<div class="divPrincipal">
    <div @items class="col-md-12 col-sm-12 ">
        <div class="container">
            <h1 class="mat-h1 divTitulo">
                <strong><span class="spanDom">Smart</span> <span class="spanCloud"> DOM</span> - <span class="spanDom"> <img
                        src="assets/images/logocondessf.png" height="90px"> MUNICIPALIDAD DE LAS CONDES</span></strong>
            </h1>
            <h2 class="subTitulo">
            <strong> Tus trámites de obra en línea</strong>
            </h2>
        </div>
        <div class="container">
            <div style="text-align: center ; padding-bottom: 50px;">
            <span class="servicioSpan"><strong> Servicios</strong></span>
            </div>
            <div class="col-md-3 col-sm-3 cardOptions" *ngFor="let item of options" align="center">
                <mat-card class="muni-card" (click)="sign(item.active, item.url)" align="center">
                    <mat-card-header align="center">
                        <div class="col-md-12 col-sm-12 mat-name" align="center">
                            <mat-card-title>
                                <h2 class="subTitulo2">
                                    <strong>{{item.name}}</strong>
                                </h2>
                            </mat-card-title>
                        </div>
                    </mat-card-header>
                    <mat-card-content class="contentcard" align="center">
                        <img class="iconService" mat-card-image [src]="item.img">
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
     <footer>
        <div style="background-color: #262626; color: white">
            <p align="center">MUNICIPALIDAD DE LAS CONDES - DIRECCION DE OBRAS</p>
            <p align="center">Av Maquehue 1441</p>
            <p align="center"><a href="www.lascondes.cl">www.lascondes.cl</a></p>
        </div>
    </footer> 
</div> -->
<div class="header">
    <span>
        <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
    </span>
    <div class="logout-container" *ngIf="identity || token">
        <span style="margin-right: 10px;"> <b>{{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}</b> </span>
        <button class="logout-btn" (click)="logout()">Cerrar Sesión</button>
    </div>
</div>

<div class="bg-color">

    <section class="wrapper">
        <div class="container-fostrap">
            <div class="content">
                <div class="container">
                    <div class="row">
                        <h1 class="title-section">SERVICIOS SMARTDOM</h1>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-8 col-xl-8">
                            <div *ngFor="let item of options">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12" *ngIf="item.active">
                                    <div class="card" *ngIf="item.active" [ngClass]="getClassCardItem(item.name)">
                                        <!-- <a class="img-card" (click)="sign(item.active, item.url)">
                                            <img src="{{item.img}}" />
                                        </a> -->
                                        <div class="card-content" (click)="sign(item.active, item.url)">
                                            <h4 class="card-title">
                                                <a>{{ item.name }}</a>
                                            </h4>
                                            <!--   <p class="parag"> {{ item.description }} </p> -->
                                            <div style="margin-top: 6%;">
                                                <div *ngIf='item.url == "certificados"'>
                                                    <li *ngFor="let i of pagoLinea" class="special-list">{{ i }} </li>
                                                </div>
                                                <div *ngIf='item.url == "expedientes"'>
                                                    <li *ngFor="let i of espedienteLinea" class="special-list">{{ i }}
                                                    </li>
                                                </div>
                                                <div *ngIf='item.url == "vivienda"'>
                                                    <li *ngFor="let i of pagoRetiro" class="special-list">{{ i }} </li>
                                                </div>
                                                <!--
                                                <div *ngIf='item.url == "noticias"'>
                                                    <li *ngFor="let i of noticias" class="special-list">{{ i }} </li>
                                                </div>
                                                -->
                                            </div>
                                        </div>

                                        <div class="card-read-more">
                                            <a class="btn btn-link btn-block" (click)="sign(item.active, item.url)">Ver
                                                Más</a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-4 col-xl-4">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                                <div class="card-2">
                                    <p><span class="card-2-title">INFORMACIÓN GENERAL</span></p>
                                    <a [routerLink]="['/aux/documentos']"><img class="img-card-2"
                                            src="../../../assets/images/new-icons-pa/icono-card-22.png"></a>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                                <div class="card-2">
                                    <p><span class="card-2-title">CONSULTAS FRECUENTES</span></p>
                                    <img class="img-card-2" src="../../../assets/images/new-icons-pa/icono-card-23.png">
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                                <div class="card-2">
                                    <p><span class="card-2-title">CONTACTOS DOM</span></p>
                                    <a [routerLink]="['/contactos']"><img class="img-card-2"
                                            src="../../../assets/images/new-icons-pa/icono-card-24.png"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="ftr">
        <p class="ftr-txt">{{footer}}</p>
        <a [href]="webUrl" target="_blank"> {{web}}</a>
    </section>
</div>
<!-- Routed view  -->
<router-outlet></router-outlet>